import { useElementWidth } from './use-element-width';

export function useHasSpaceForCtaSidePreview(sideBarRef: React.RefObject<HTMLDivElement>): boolean {
    const sideBarWidth = useElementWidth(sideBarRef);

    return sideBarWidth >= 500;
}
